import {useParams} from "react-router-dom";
import styles from "./SAML.module.css";
import {ReactComponent as YuJaLogo} from "../../images/yujalogo.svg";
import {ReactComponent as Success} from "./images/success.svg";
import React from "react";
import { BsXCircle } from "react-icons/bs";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useTranslation } from "react-i18next";

export default function MobileSSOLoginPage() {
    const { t } = useTranslation();
    const { result, endType } = useParams();
    const window = useWindowDimensions();

    return (
        <div className={styles.container}>
            <div className={styles.titleContainer}>
                {window.width < 1000 ?
                    <YuJaLogo style={{marginRight: "5px", width: 60, height: 60, alignSelf: 'center'}}/>
                    : <YuJaLogo style={{marginRight: "5px", width: 95, height: 95, alignSelf: 'center'}}/>
                }
                <div className={styles.title} style={{fontSize: window.width < 1000 ? 32 : 40, lineHeight: 1.4,}}>{t("common.appName")}</div>
            </div>
            {result === 'success' &&
                <div className={styles.resultBox} style={{width: window.width < 650 ? '80%' : 600}}>
                    {window.width < 1000 ?
                        <Success style={{width: 60, height: 60}}/>
                        : <Success />
                    }

                    <div className={styles.resultTitle} style={{fontSize: window.width < 1000 ? 23 : 32, lineHeight: 1.6,}}>{t("auth.mobileSsoLoginSuccess")}</div>
                    <div className={styles.description} style={{fontSize: window.width < 1000 ? 16 : 24, lineHeight: window.width < 1000 ? 1.5 : 1.4,}}>
                        {t("poll.ssoLoginPowerpointSuccess")} <br/>
                        {endType === 'mobile' &&
                            t("auth.mobileSsoRedirecting")
                        }
                        {endType === 'ppt' &&
                            t("poll.ssoLoginPowerpointText")
                        }
                    </div>
                </div>

            }

            {result !== 'success' &&
                <div className={styles.resultBox} style={{width: window.width < 650 ? '80%' : 600}}>
                    {window.width < 1000 ?
                        <BsXCircle style={{width: 60, height: 60}}/>
                        : <BsXCircle style={{width: 90, height: 90}}/>
                    }

                    <div className={styles.resultTitle} style={{fontSize: window.width < 1000 ? 23 : 32, lineHeight: 1.6,}}>{t("auth.mobileSsoLoginFailed")}</div>
                    <div className={styles.description} style={{fontSize: window.width < 1000 ? 16 : 24, lineHeight: window.width < 1000 ? 1.5 : 1.4,}}>
                        {t("poll.ssoLoginPowerpointFailed")} <br/>
                        {endType === 'ppt' &&
                            t("poll.ssoLoginPowerpointText")
                        }
                    </div>
                </div>

            }
        </div>
    );
}